/**
 * SMS Manifest — declares cross-entity reuse for the send-text-message action.
 *
 * Now usable from contact, deal, company, ticket, time_entry, communication,
 * recurring_charge, recurring_transaction — the resolver walks to a contact
 * automatically. Bulk mode allows sending to all/some contacts at a company.
 */

import { registerActionManifest } from "./registry";

registerActionManifest({
  actionId: "send-text-message",
  label: "Send text",
  primaryEntity: "contact",
  requires: {
    entity: "contact",
    requiredFields: ["phone"],
    allowMulti: true,
    bulkMax: 50,
    extraInputs: [
      {
        name: "body",
        kind: "textarea",
        label: "Message",
        required: true,
        placeholder: "Type your message…",
      },
      {
        name: "fromNumber",
        kind: "select",
        label: "Send from",
        required: true,
        placeholder: "Pick an OpenPhone line",
        // Server resolves to current OpenPhone lines via
        // fieldOptionsLoaders["openphone-lines"]. Client receives populated
        // `options` and renders a select dropdown.
        optionsSource: "openphone-lines",
      },
    ],
  },
});
